/** Google Routes alapú vezetési távolság (km), backend proxy. */
export async function fetchDrivingDistanceKm(
  originPlaceId,
  destinationPlaceId,
  originAddress,
  destinationAddress,
) {
  const apiBase = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8003').replace(/\/$/, '');
  const response = await fetch(`${apiBase}/api/distance/driving-km`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      originPlaceId,
      destinationPlaceId,
      originAddress,
      destinationAddress,
    }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || 'Nem sikerült a távolság számítása.');
  }
  const distanceKm = Number(data?.distanceKm);
  if (!Number.isFinite(distanceKm) || distanceKm <= 0) {
    throw new Error('Érvénytelen távolság érték érkezett.');
  }
  return Math.round(distanceKm);
}
